<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- DROPDOWN -->
<div
	[formGroup]="editForm"
	#animationElement
	class="light-container-popup-basic variance-prompt variance-prompt--edit"
>
	<div class="light-container__text-block">{{ strings.TICKET_VARIANCE_SUB_HEADER }}</div>
	<ticket-variance
		formControlName="varianceId"
		[varianceList]="variance$"
		class="input-spacing-v"
	></ticket-variance>
	<textarea
		[placeholder]="strings.TICKET_VARIANCE_COMMENTS_PLACEHOLDER"
		formControlName="varianceComment"
		automationId="varianceComment"
		class="input-spacing-v variance-prompt__textarea"
	></textarea>

	<div class="light-container-popup__footer">
		<button class="legacy-button btn--white input-spacing-h" *ngIf="showCancelButton" (click)="cancel()">
			Cancel
		</button>
		<button class="legacy-button btn-blue" (click)="save()" [disabled]="editForm.invalid">
			{{ saveButtonText }}
		</button>
	</div>
</div>
